import * as React from 'react';
import { connect } from 'react-redux';

import AddNew from 'components/buttons/add-new/AddNew';

import { addEmptyEntity } from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';

import './create-new-profiles-entities-list-add-new.scss';

applyTranslations(require('./create-new-profiles-entities-list-add-new.i18n.json'));

interface Props {
  dispatchAddNewEntity: () => void
}

const CreateNewProfilesEntitiesListAddNew = ({
  dispatchAddNewEntity
}: Props): JSX.Element => (
  <div className="create-new-profiles-entities-list-add-new">
    <div
      className="create-new-profiles-entities-list-add-new__inner-container"
      onClick={dispatchAddNewEntity}
    >
      <AddNew
        icon={{
          name: 'plus-inside-circle-custom-bg',
          height: 24,
          width: 24
        }}
        text={__t('create_new_profiles_entities_list_add_new.add_new')}
      />
    </div>
  </div>
);

const mapDispatchToProps = (dispatch): Props => ({
  dispatchAddNewEntity: () => dispatch(addEmptyEntity())
});

export default connect(null, mapDispatchToProps)(CreateNewProfilesEntitiesListAddNew);
